import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../RushShell/icons';

const FILTERS = ['All', 'Mine', 'This week', 'Late'];

const ext = (project) => {
    const fname = project.fileName || project.sourceFile || '';
    const m = /\.([a-z0-9]+)$/i.exec(fname);
    return (m ? m[1] : 'DOC').slice(0, 3).toUpperCase();
};

const fileClass = (e) => {
    const c = e.toLowerCase();
    if (c === 'idm' || c === 'idml') return 'idm';
    if (c === 'jso' || c === 'json') return 'jso';
    if (c === 'xli' || c === 'xlf') return 'xli';
    if (c === 'md') return 'md';
    return '';
};

const ownerInitials = (member, idx) => {
    if (!member) return `U${idx}`;
    const n = `${member.firstName || ''} ${member.lastName || ''}`.trim();
    if (n) return n.split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase();
    return (member.email || `U${idx}`).slice(0, 2).toUpperCase();
};

const avatarPalette = (idx) => `av-${(idx % 6) + 1}`;

const formatDue = (deadline) => {
    if (!deadline) return '—';
    const d = new Date(deadline);
    if (Number.isNaN(d.getTime())) return '—';
    const now = new Date();
    const diff = Math.round((d - now) / (1000 * 60 * 60 * 24));
    if (diff < 0) return 'Overdue';
    if (diff === 0) return 'Today';
    if (diff === 1) return 'Tomorrow';
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

const dueClass = (deadline, status) => {
    if (!deadline || status === 'done') return '';
    const diff = Math.round((new Date(deadline) - Date.now()) / (1000 * 60 * 60 * 24));
    if (diff < 0) return 'warn';
    if (diff <= 1) return 'soon';
    return '';
};

const statusFor = (p) => {
    if (p.completed) return 'done';
    if ((p.progress || 0) >= 85) return 'review';
    if ((p.progress || 0) === 0) return 'queued';
    if (p.blocked) return 'blocked';
    return 'live';
};

const ProjectsCard = ({ projects = [], filter, setFilter, userId }) => {
    const now = Date.now();
    const filtered = projects.filter((p) => {
        if (filter === 'All') return true;
        if (filter === 'Mine') return p.owner === userId || p.createdBy === userId;
        if (filter === 'This week') {
            if (!p.deadline) return false;
            const diff = (new Date(p.deadline) - now) / (1000 * 60 * 60 * 24);
            return diff >= 0 && diff <= 7;
        }
        if (filter === 'Late') return p.deadline && new Date(p.deadline).getTime() < now && !p.completed;
        return true;
    });

    return (
        <div className="rs-card col-8">
            <div className="rs-card-h">
                <h3>Active projects</h3>
                <span className="count">{filtered.length}</span>
                <div className="chip-row">
                    {FILTERS.map((f) => (
                        <button key={f} type="button" className={`chip ${filter === f ? 'on' : ''}`} onClick={() => setFilter(f)}>
                            {f}
                        </button>
                    ))}
                </div>
                <div className="spacer" />
                <Link className="link" to="/dashboard/projects">
                    View all {Icon.arrow}
                </Link>
            </div>
            <div className="ptbl">
                <div className="ptbl-row head">
                    <span>Project</span>
                    <span>Source → target</span>
                    <span>Progress</span>
                    <span>Owners</span>
                    <span>Due</span>
                    <span>Status</span>
                    <span />
                </div>
                {filtered.length === 0 && (
                    <div className="ptbl-row body" style={{ gridTemplateColumns: '1fr', justifyItems: 'center', color: 'var(--muted)' }}>
                        <span>No projects match this filter.</span>
                    </div>
                )}
                {filtered.slice(0, 6).map((p) => {
                    const e = ext(p);
                    const src = (p.sourceLanguage || 'EN').slice(0, 2).toUpperCase();
                    const targets = (p.targetLanguages || []).map((l) => (l.code || l).slice(0, 2).toUpperCase());
                    const visibleTargets = targets.slice(0, 4);
                    const extra = targets.length - visibleTargets.length;
                    const owners = (p.collaborators || (p.owners || [])).slice(0, 3);
                    const status = statusFor(p);
                    const pct = Math.round(p.progress || 0);
                    return (
                        <Link to={`/dashboard/projects/${p._id}`} className="ptbl-row body" key={p._id} style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="p-name">
                                <span className={`fic ${fileClass(e)}`}>{e}</span>
                                <span className="nm-wrap">
                                    <b>{p.name}</b>
                                    <span>{p.category || 'Project'}</span>
                                </span>
                            </div>
                            <div className="p-langs">
                                <span className="p-lang src">{src} →</span>
                                {visibleTargets.map((l) => (
                                    <span key={l} className="p-lang">{l}</span>
                                ))}
                                {extra > 0 && <span className="p-lang more">+{extra}</span>}
                            </div>
                            <div className="p-prog">
                                <span className="bar"><span style={{ width: `${pct}%` }} /></span>
                                <span className="pct">{pct}%</span>
                            </div>
                            <div className="p-owners">
                                {owners.map((o, i) => (
                                    <span key={i} className={`av-s ${avatarPalette(i)}`}>{ownerInitials(o, i)}</span>
                                ))}
                            </div>
                            <div className={`p-due ${dueClass(p.deadline, status)}`}>{formatDue(p.deadline)}</div>
                            <span className={`p-status ${status}`}>
                                <span className="pulse" />{status}
                            </span>
                            <span className="more">{Icon.more}</span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default ProjectsCard;
